<div class="product" [class.menuoffer]="menu.offer">
    <div class="info" (click)="menu.showcomp=!menu.showcomp"
        *ngIf="menu.compositions.elements.length>0 || menu.compositions.families.length>0">
        <img src="assets/images/info.png" alt="">
    </div>
    <div class="flip-container" [class.flipped]="menu.showcomp">
        <div class="flipper">
            <div easyzoom *ngIf="loadAvatar" class="main-img"
                [ngClass]="{easyzoom:!menu.showcomp,'easyzoom--overlay':!menu.showcomp}">
                <img [src]="menu.avatar|absolutePath:'menus'" [attr.data-zoom-image]="menu.avatar|absolutePath:'menus'"
                    [alt]="'Livraison '+menu.category+' '+menu.name"
                    [title]="'Livraison '+menu.category+' '+menu.name" />
            </div>
            <div class="main-img" *ngIf="!loadAvatar">
                <div class="loading"></div>
                <img appLazyLoad (lodedImage)="loadAvatar=true" [src]="menu.avatar|absolutePath:'menus'"
                    [alt]="'Livraison '+menu.category+' '+menu.name"
                    [title]="'Livraison '+menu.category+' '+menu.name" />
            </div>
            <div class="compositions back" *ngIf="menu.showcomp">
                <div style="display: table-cell;vertical-align: middle;">
                    <ul>
                        <ng-container *ngIf="menu.compositions.elements.length>0">
                            <li *ngFor="let comp of menu.compositions.elements[0]; let i=index;">
                                <b *ngIf="comp.quantity>1">{{comp.quantity}}</b> {{comp.name}} <ng-container
                                    *ngIf="comp.level">
                                    ({{comp.size}})</ng-container>
                            </li>
                        </ng-container>
                        <ng-container *ngFor="let comp of menu.compositions.elements; let i=index;">
                            <ng-container *ngIf="i>0 && comp.length >0">
                                <li>
                                    <ng-container *ngFor="let el of comp;let j=index">
                                        <b *ngIf="el.quantity>1">{{el.quantity}}</b> {{el.name}} <ng-container
                                            *ngIf="el.level">
                                            ({{el.size}}) </ng-container>
                                        <b *ngIf="j!=comp.length-1">OU </b>
                                    </ng-container>
                                </li>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="menu.compositions.families.length>0">
                            <li *ngFor="let comp of menu.compositions.families[0]; let j=index;">
                                <b *ngIf="comp.quantity>1">{{comp.quantity}}</b> {{comp.label}} <ng-container
                                    *ngIf="comp.level">
                                    ({{comp.size}})</ng-container>
                            </li>
                        </ng-container>
                        <ng-container *ngFor="let comp of menu.compositions.families; let i=index;">
                            <ng-container *ngIf="i>0 && comp.length >0">
                                <li>
                                    <ng-container *ngFor="let el of comp;let j=index">
                                        <b *ngIf="el.quantity>1">{{el.quantity}}</b> {{el.label}} <ng-container
                                            *ngIf="el.level">
                                            ({{el.size}}) </ng-container>
                                        <b *ngIf="j!=comp.length-1">OU </b>
                                    </ng-container>
                                </li>
                            </ng-container>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="product-body">
        <h2>{{menu.title}}</h2>
    </div>
    <div class="product-footer">
        <div class="size vcenter" [class.opa]="siteClose" *ngIf="!menu.offer">
            <div class="price text-right">
                {{menu.price | number: '1.1-2'}} €
            </div>
        </div>
        <ng-container *ngIf="menu.dispoday">
            <ng-container *ngIf="menu.dispo">
                <div class="row" *ngIf="menu.validPeriod==1">
                    <div class="col-md-12">
                        <button class="add menu btn" aria-hidden="true" (click)="addToBasket()" [disabled]="siteClose">
                            Ajouter au panier
                            <img src="assets/images/add.png" alt="" srcset="">
                        </button>
                    </div>
                </div>
                <div class="row" *ngIf="menu.validPeriod==0">
                    <div class="col-md-12">
                        <button class="btn indisponible" *ngIf="menu.menuTime==1">Disponible midi uniquement</button>
                        <button class="btn indisponible" *ngIf="menu.menuTime==3">Disponible soir uniquement</button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="!menu.dispo">
                <div class="row">
                    <div class="col-md-12">
                        <button class="btn indisponible">{{orderName}} NON DISPONIBLE</button>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!menu.dispoday">
            <div class="row">
                <div class="col-md-12">
                    <button class="btn indisponible">NON DISPONIBLE AUJOURD'HUI</button>
                </div>
            </div>
        </ng-container>
    </div>
</div>